module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "720px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-document-multiple")]), _vm._v("Payment Invoices\n      ")], 1)]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v(_vm._s(_vm.recordTitle))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    ref: "invoiceInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*,.pdf,.ppt,.pptx,.txt,.doc,.docx,.xls,.xlsx"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$refs.invoiceInput.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-cloud-upload")]), _vm._v("Select Invoices\n          ")], 1), _vm._v(" "), (_vm.files.length) ? _c('span', {
    staticClass: "ml-2 caption"
  }, [_vm._v(_vm._s(_vm.files.length) + " selected")]) : _vm._e()], 1), _vm._v(" "), (_vm.files.length) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.files), function(file, index) {
    return _c('v-chip', {
      key: file.name + index,
      staticClass: "ma-1",
      attrs: {
        "close": "",
        "small": ""
      },
      on: {
        "click:close": function($event) {
          return _vm.removeFile(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(file.name) + "\n          ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.displayInvoices,
      "items-per-page": 5,
      "no-data-text": "No invoices uploaded"
    },
    scopedSlots: _vm._u([{
      key: "item.filename",
      fn: function(ref) {
        var item = ref.item;

        return [_c('a', {
          attrs: {
            "href": item.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.filename || 'Invoice'))])]
      }
    }, {
      key: "item.source",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "small": "",
            "color": item.deletable ? 'secondary' : 'grey lighten-1',
            "text-color": "white"
          }
        }, [_vm._v("\n                " + _vm._s(item.source) + "\n              ")])]
      }
    }, {
      key: "item.timestamp",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n              " + _vm._s(_vm.formatDate(item.timestamp || item.uploadedAt)) + "\n            ")]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "small": "",
            "href": item.url,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-download")])], 1), _vm._v(" "), (item.deletable) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "error",
            "small": "",
            "disabled": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.deleteInvoice(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "white"
          }
        }, [_vm._v("mdi-delete")])], 1) : _vm._e()]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red darken-1",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "green darken-1",
      "disabled": !_vm.files.length || _vm.loading
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("\n        Upload\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c0422de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/PaymentInvoiceModal.vue
// module id = 2144
// module chunks = 0